import './entrada.css';

const CANTOS = ['canto--no', 'canto--ne', 'canto--so', 'canto--se'] as const;
const BRASAS = 24;
const TAMANHOS = 'max(100vw, calc(100vh * 16 / 9))';

function Canto({ classe }: { classe: string }) {
  return (
    <svg className={`canto ${classe}`} viewBox="0 0 74 74" fill="none" aria-hidden="true">
      <path d="M2 34 C2 16 16 2 34 2" stroke="rgba(201,162,39,.5)" strokeWidth="1.4" />
      <path d="M9 40 C9 22 22 9 40 9" stroke="rgba(201,162,39,.24)" strokeWidth="1" />
      <path d="M2 2 L2 16 M2 2 L16 2" stroke="var(--gold)" strokeWidth="2.2" />
      <circle cx="21" cy="21" r="3.2" fill="none" stroke="rgba(201,162,39,.62)" strokeWidth="1.2" />
      <path d="M21 14 L21 17 M21 25 L21 28 M14 21 L17 21 M25 21 L28 21" stroke="rgba(201,162,39,.45)" strokeWidth="1.2" />
    </svg>
  );
}

/** Fundo da tela de entrada: pintura, véu, luz, brasas e moldura. */
export function CenaDeEntrada() {
  return (
    <>
      <picture className="cena-caixa">
        <source
          type="image/avif"
          sizes={TAMANHOS}
          srcSet="/entrada/fundo-1200.avif 1200w, /entrada/fundo-2000.avif 2000w"
        />
        <source
          type="image/webp"
          sizes={TAMANHOS}
          srcSet="/entrada/fundo-1200.webp 1200w, /entrada/fundo-2000.webp 2000w"
        />
        <img
          className="cena"
          src="/entrada/fundo-1200.jpg"
          alt=""
          width={2000}
          height={1125}
          decoding="async"
          fetchPriority="high"
        />
      </picture>

      <svg className="grao" aria-hidden="true">
        <filter id="grao-f" x="0" y="0" width="100%" height="100%">
          <feTurbulence type="fractalNoise" baseFrequency=".85" numOctaves="3" seed="5" />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#grao-f)" />
      </svg>

      <div className="veu" />
      <div className="luz" />
      <div className="brasas" aria-hidden="true">
        {Array.from({ length: BRASAS }, (_, i) => <i key={i} />)}
      </div>
      <div className="moldura">
        {CANTOS.map(c => <Canto key={c} classe={c} />)}
      </div>
    </>
  );
}
